import React, { useEffect, useState } from 'react';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import { HomeOutlined, EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Breadcrumb, Pagination, ConfigProvider, BackTop, Image } from 'antd';
import { Table, Tooltip, Button } from 'antd';
import TableDateRow from 'modules/layoutModule/components/TableDateRow/TableDateRow';
import plPL from 'antd/lib/locale/pl_PL';
import moment from 'moment';
import TableDataRowTypes from 'modules/layoutModule/enums/TableDataRowTypes';
import useColumnSearch from 'modules/layoutModule/hooks/useColumnSearch';
import { getBannersRequest } from '../requests/bannersRequests';
import staticUrl from '../../../helpers/staticUrl';
import { StaticImagesFallbackUrl } from '../../layoutModule/consts/StaticImagesFallbackUrl';

export interface NewsTableTypes {
  id: number;
  dateAdd: moment.MomentInput;
  name: string;
  isActive: number;
}

const Banners = (): JSX.Element => {
  const [tableData, setTableData] = useState<NewsTableTypes[]>([]);
  const [loading, toggleLoading] = useState<boolean>(true);
  const [searchedColumn, setSearchedColumn] = useState('');

  const downloadBanners = () =>
    getBannersRequest().then((response) => {
      if (response) {
        setTableData(response);
        toggleLoading(false);
      } else {
        toggleLoading(false);
      }
    });

  useEffect(() => {
    if (tableData.length === 0) {
      downloadBanners();
    }
  }, [tableData]);

  const columns = [
    {
      title: 'Lokalizacja',
      dataIndex: 'id',
      key: 'id',
      render: (id: string) => (
        <Image
          width={142}
          src={`${staticUrl()}banery/${id}.jpg`}
          fallback={StaticImagesFallbackUrl}
          preview={false}
        />
      ),
    },
    {
      title: 'Kampania',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: { name: string }, b: { name: string }) =>
        a.name.localeCompare(b.name),
      ...useColumnSearch(
        'name',
        'Szukaj po kampani',
        'Szukaj',
        'Resetuj',
        searchedColumn,
        setSearchedColumn
      ),
    },
    {
      title: 'Desktop',
      dataIndex: 'fileImage1',
      key: 'fileImage1',
      render: (text: string, record: any) => (
        <TableDateRow
          record={record}
          field={TableDataRowTypes.BANNERS}
          fieldName="fileImage1"
          size={250}
        />
      ),
    },
    {
      title: 'Mobile',
      dataIndex: 'fileImage1Mobile',
      key: 'fileImage1Mobile',
      render: (text: string, record: any) => (
        <TableDateRow
          record={record}
          field={TableDataRowTypes.BANNERS}
          fieldName="fileImage1Mobile"
          size={100}
        />
      ),
    },
    {
      title: 'Url',
      dataIndex: 'bannerURL',
      key: 'bannerURL',
      sorter: (a: { bannerURL: string }, b: { bannerURL: string }) =>
        a.bannerURL.localeCompare(b.bannerURL),
      ...useColumnSearch(
        'bannerURL',
        'Szukaj po url',
        'Szukaj',
        'Resetuj',
        searchedColumn,
        setSearchedColumn
      ),
    },
    {
      title: 'Target',
      dataIndex: 'target',
      key: 'target',
    },
    {
      title: 'Aktywna',
      dataIndex: 'isActive',
      key: 'isActive',
      width: '150px',
      render: (text: string, record: any) => (
        <TableDateRow record={record} field={TableDataRowTypes.IS_ACTIVE} />
      ),
      sorter: (a: { isActive: number }, b: { isActive: number }) =>
        a.isActive - b.isActive,
      filters: [
        {
          text: 'TAK',
          value: 'isActive',
        },
        {
          text: 'NIE',
          value: 'isNotActive',
        },
      ],
      onFilter: (value: string, record: { isActive: boolean }) => {
        if (value === 'isActive') {
          return record.isActive;
        }
        return !record.isActive;
      },
    },
    {
      title: 'Akcje',
      dataIndex: 'operation',
      key: 'operation',
      width: 100,
      render: (text: string, item: NewsTableTypes) => (
        <Tooltip title="Edytuj wpis">
          <Link to={`/banners/${item.id}`}>
            <Button type="primary" shape="circle" icon={<EditOutlined />} />
          </Link>
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/banners">Reklamy banerowe</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <Table
          // @ts-ignore
          columns={columns}
          // @ts-ignore
          dataSource={tableData}
          loading={loading}
          rowKey={(record) => record.id}
        >
          <Pagination />
        </Table>
        <BackTop />
      </ConfigProvider>
    </>
  );
};

export default Banners;
